import {Component} from "@angular/core";
import {Card, CardDomiciliationModel} from "../../../models/loyalty-card.model";
import {
  CustomerCardSearchModelFilter,
  CustomerCardSearchModelFilterTypes
} from "../../customerDB/widget/customer-card-search/customer-card-search.model";
import {MessageService, SelectItem} from "primeng/api";
import {TranslateService} from "@ngx-translate/core";
import {LoyaltyCardService} from "../../../services/loyalty/loyalty-card.service";
import {StoreCommonService} from "../../../services/store/store-common.service";

@Component({
  selector: 'kv-loyalty-domiciliation-massive-range',
  template: `
    <div class="ui-g-12">
      <div class="ui-g-6">
        <div class="ui-g-12">
          <div [kv-form-element]="{ label: 'loyalty.domiciliation_card_from', md: '10'}">
            <input style="{width:100%;}" pInputText type="text" [value]="cardFrom ? cardFrom.card_no : ''" [readOnly]="true" >
          </div>
          <div class="ui-g-1" style="padding-top: 45px;">
            <p-button pTooltip="{{ 'common.select' | translate }}" icon="fa fas fa-arrow-circle-right"  styleClass="ui-button-info" (onClick)="onOpenSearchCardFrom()"></p-button>
          </div>
        </div>
        <div class="ui-g-12" style="text-align: center;" *ngIf="showSearchCardFrom">
          <i style="font-size: 30px;" class="fa fa-fw fa-caret-down"></i>
        </div>
      </div>

      <div class="ui-g-6">
        <div class="ui-g-12">
          <div [kv-form-element]="{ label: 'loyalty.domiciliation_card_to', md: '10'}">
            <input style="{width:100%;}" pInputText type="text" [value]="cardTo ? cardTo.card_no : ''" [readOnly]="true" [disabled]="cardFrom == null">
          </div>
          <div class="ui-g-1" style="padding-top: 45px;">
            <p-button pTooltip="{{ 'common.select' | translate }}" icon="fa fas fa-arrow-circle-right"  styleClass="ui-button-info" (onClick)="onOpenSearchCardTo()" [disabled]="cardFrom == null"></p-button>
          </div>
        </div>
        <div class="ui-g-12" style="text-align: center;" *ngIf="showSearchCardTo">
          <i style="font-size: 30px;" class="fa fa-fw fa-caret-down"></i>
        </div>
      </div>
      
      <div *ngIf="cardDomiciliationRange != null">
        <div class="ui-g-12">
          <div [kv-form-element]="{ label: 'loyalty.domiciliation_card_massive_range_total', md: '4'}">
          </div>
          <div class="ui-g-8" style="text-align: center;">
            <label style="{width:100%;}" style="text-align: center;" >{{cardDomiciliationRange.length}}</label>
          </div>
        </div>
        <div class="ui-g-12">
          <div [kv-form-element]="{label: 'card.domiciliation_select_store', md: '12'}">
            <p-dropdown [(ngModel)]="destinationStore" [options]="filteredStoresListItem"></p-dropdown>
          </div>
        </div>
        <div class="ui-g-12" *ngIf="cardDomiciliationRange != null">
          <div class="ui-g-4"></div>
          <div class="ui-g-4">
            <button pButton type="button" class="buttonExpand k-generic-btn" icon="fa fa-search" iconPos="left" [label]="'loyalty.domiciliation_massive_range_perform' | translate" (click)="performDomiciliation()" ></button>
          </div>
          <div class="ui-g-4"></div>
        </div>
      </div>
      
    </div>
    
    <kv-customer-card-search
      *ngIf="showSearchCardFrom && !showSearchCardTo"
      (onCardSelect)="onCardFromSelect($event)"
      (onBack)="showSearchCardFrom = false"
    ></kv-customer-card-search>
    <kv-customer-card-search
      *ngIf="!showSearchCardFrom && showSearchCardTo && filterLoyaltyChannel.type != 0"
      (onCardSelect)="onCardToSelect($event)"
      (onBack)="showSearchCardTo = false"
      [filter]="filterLoyaltyChannel"
    ></kv-customer-card-search>
    
    
  `,
  styles: [
    `
      .Customers .ui-inputtext {
        text-align: center;
      }
    `
  ]
})
export class LoyaltyDomiciliationMassiveRangeComponent {
  translations = {}
  cardFrom: Card = null;
  cardTo: Card = null;
  showSearchCardFrom = false;
  showSearchCardTo = false;
  filteredStoresListItem: SelectItem[];
  destinationStore: any;


  cardDomiciliationRange: Card[] = null;

  filterLoyaltyChannel: CustomerCardSearchModelFilter = {
    filterCard: null,
    type: CustomerCardSearchModelFilterTypes.None
  }

  constructor(
    private notification: MessageService,
    private translate: TranslateService,
    private svcCard: LoyaltyCardService,
    private svcStore: StoreCommonService
  ) {
    this.translate.get([
      'loyalty.domiciliation_range_error_summary',
      'loyalty.domiciliation_range_error_detail',
      'loyalty.domiciliation_cast_error_summary',
      'loyalty.domiciliation_cast_error_detail',
      'loyalty.domiciliation_massive_ok_summary',
      'loyalty.domiciliation_massive_ok_detail'
    ]).subscribe(t => {
      this.translations = t
    })

  }

  onOpenSearchCardFrom() {
    this.showSearchCardFrom = true;
    this.showSearchCardTo = false;

  }

  onOpenSearchCardTo() {
    this.showSearchCardTo = true;
    this.showSearchCardFrom = false;

  }

  onCardFromSelect(card: Card) {
    this.cardFrom = card;
    this.filterLoyaltyChannel = {
      type: CustomerCardSearchModelFilterTypes.LoyaltyChannel,
      filterCard: card
    }
    this.showSearchCardFrom = false;
  }

  onCardToSelect(card: Card) {
    try {
      let card_number_from: number = parseInt(this.cardFrom.card_no)
      let card_number_to: number = parseInt(card.card_no)
      if (card_number_to < card_number_from) {
        this.notification.add({severity: 'error', summary: this.translations['loyalty.domiciliation_range_error_summary'], detail: this.translations['loyalty.domiciliation_range_error_detail']})
      }
      else {
        this.cardTo = card;
        this.showSearchCardTo = false;
        let params = Array<{ key: string, value: string }>();
        params.push({
          key: 'min_card_no',
          value: card_number_from.toString()
        })
        params.push({
          key: 'max_card_no',
          value: card_number_to.toString()
        })
        params.push({
          key: 'channelCode',
          value: this.cardFrom.channelCode
        })
        this.svcCard.list(null, null, params).subscribe(items => {
          this.cardDomiciliationRange = items.data
        })

        this.svcStore.getListFilteredByChannel(parseInt(this.cardFrom.channel_id)).subscribe(stores => {
          this.filteredStoresListItem = [{
            label: '',
            value: null
          }]
          stores.forEach(s => {
            this.filteredStoresListItem.push({
              value: s.id,
              label: s.code + " - " + s.name
            })
          })
        })

      }
    }
    catch (e) {
      this.notification.add({severity:'warning', summary: this.translations['loyalty.domiciliation_cast_error_summary'], detail: this.translations['loyalty.domiciliation_cast_error_detail']})
    }



  }

  performDomiciliation() {
    let domiciliations : CardDomiciliationModel[] = [];
    this.cardDomiciliationRange.forEach(card => {
      domiciliations.push({
        store_from: parseInt(card.store_id),
        card_id: parseInt(card.id),
        store_to: this.destinationStore
      })
    })

    this.svcCard.massiveDomiciliate(domiciliations).subscribe(res => {
      this.notification.add({severity:'success', summary: this.translations['loyalty.domiciliation_massive_ok_summary'], detail: this.translations['loyalty.domiciliation_massive_ok_detail'] + ": " + res})
    })


  }

}



// WEBPACK FOOTER //
// ./src/app/views/loyalty/loyalty-domiciliation/loyalty-domiciliation-massive-range.component.ts